(() => {
  if (window.rkAutumnNoticeInitialized) return;
  window.rkAutumnNoticeInitialized = true;
  const pad = n => String(n).padStart(2, '0');
  const mobile = window.matchMedia('(max-width:749px)');
  function render(bar) {
    const now = Date.now(), start = Date.parse(bar.dataset.start), end = Date.parse(bar.dataset.end);
    if (!Number.isFinite(start) || !Number.isFinite(end) || now >= end || bar.dataset.closed === 'true') { bar.hidden = true; return; }
    const finalDay = new Date(end).toLocaleDateString('en-CA', {timeZone:'Asia/Tokyo'}) === new Date(now).toLocaleDateString('en-CA', {timeZone:'Asia/Tokyo'});
    const phase = now < start ? 'before' : finalDay ? 'final' : 'active';
    bar.dataset.phase = phase;
    const seconds = Math.floor(((phase === 'before' ? start : end) - now) / 1000);
    const values = [Math.floor(seconds/86400),Math.floor(seconds%86400/3600),Math.floor(seconds%3600/60),seconds%60];
    const units = bar.dataset.units.split(',');
    bar.querySelector('[data-rk-label]').textContent = bar.dataset[phase + (mobile.matches ? 'Short' : '')];
    const count = bar.querySelector('[data-rk-count]');
    count.replaceChildren();
    values.forEach((value,i) => { if (phase === 'final' && i === 0) return; const num = document.createElement('span'),unit=document.createElement('span');num.className='rk-notice__num';num.textContent=pad(value);unit.className='rk-notice__unit';unit.textContent=units[i];count.append(num,unit); });
    bar.hidden = false;
  }
  function setup() {
    document.querySelectorAll('[data-rk-notice]').forEach(bar => {
      if (!bar.dataset.bound) {
        bar.dataset.bound='true';
        try {if(sessionStorage.getItem(bar.dataset.storage)==='closed') bar.dataset.closed='true';} catch (_) {}
        bar.querySelector('[data-rk-close]').addEventListener('click',()=>{bar.dataset.closed='true';bar.hidden=true;try{sessionStorage.setItem(bar.dataset.storage,'closed');}catch(_){}window.dispatchEvent(new Event('resize'));});
      }
      render(bar);
    });
  }
  setup();
  setInterval(setup,1000);
  mobile.addEventListener('change',setup);
  document.addEventListener('shopify:section:load',setup);
})();
